import { useState, useEffect } from 'react';
import FileUploader from '@/components/tasks/FileUploader';

interface ReportSectionProps {
  taskId: string;
  reportText: string | null;
  onSave: (text: string) => void;
  readOnly?: boolean;
}

export default function ReportSection({
  taskId,
  reportText,
  onSave,
  readOnly = false,
}: ReportSectionProps) {
  const [text, setText] = useState<string>(reportText ?? '');

  useEffect(() => {
    setText(reportText ?? '');
  }, [reportText]);

  const handleBlur = () => {
    onSave(text);
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-900">Report</h3>

      {readOnly ? (
        <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
          {reportText ? (
            <p className="whitespace-pre-wrap text-sm text-gray-700">{reportText}</p>
          ) : (
            <p className="text-sm italic text-gray-400">No report submitted</p>
          )}
        </div>
      ) : (
        <textarea
          value={text}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setText(e.target.value)}
          onBlur={handleBlur}
          rows={6}
          placeholder="Enter report content..."
          className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder-gray-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
        />
      )}

      <div>
        <h4 className="mb-2 text-sm font-medium text-gray-700">Attachments</h4>
        <FileUploader
          taskId={taskId}
          disabled={readOnly}
        />
      </div>
    </div>
  );
}
